import { loadImages } from "./Image";

export function generateCircleAvatar(name, size = 64, bgColor = '#1976d2', textColor = '#fff') {
  const initials = getInitials(name)
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');

  // Clip to a circle
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, true);
  ctx.closePath();
  ctx.clip();

  // Draw background
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, size, size);

  // Draw initials
  ctx.fillStyle = textColor;
  ctx.font = `${size / 2.2}px sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(initials, size / 2, size / 2);

  return canvas.toDataURL(); // Returns a base64 image
}

const getInitials = (name) => {
  const words = name.trim().split(' ').filter(Boolean);

  // if (words.length === 1) {
  //   // Single word: take first 2 letters
  //   return words[0].slice(0, 2).toUpperCase();
  // }

  // Multiple words: first letter of first and second words
  // return (words[0][0] + words[1][0]).toUpperCase();
  return words[0].slice(0, 2).toUpperCase();
};

export const getUserAvatar = (userDetail) => {
  //   if (userDetail.isGuest) { return generateCircleAvatar(userDetail.name || 'S') }
  return userDetail.profilePic ? loadImages(userDetail.profilePic) : userDetail.gender === "male" ? "" : ""
}